window.bodyFixed = function(h) {
  var fixed = h === undefined ? false : h;
  var top = document.body.getBoundingClientRect().top;

  if (fixed) {
    document.body.classList.add('noscroll');
    document.body.style.top = top + 'px';
  } else {
    document.body.classList.remove('noscroll');
    document.body.style.top = null;
    window.scrollTo(0, - top);
  }
};
